/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          waterSources: {
            type: 'string',
            enum: [
              'FRESH_SURFACE_WATER',
              'GROUNDWATER',
              'MUNICIPAL_WATER',
              'PRODUCED_OR_PROCESSED_WATER',
              'RAINWATER',
              'SEAWATER',
              'UNKNOWN_ORIGIN',
              'WATER_SOURCES_FROM_ANOTHER_ORGANIZATION',
            ],
          },
          unit: {
            type: 'string',
            enum: ['CUBIC_METRE'],
          },
          totalAnnualConsumption: {
            type: 'number',
          },
          year: {
            type: 'number',
            minimum: 1000,
            maximum: 9000,
          },
        },
        required: ['waterSources', 'unit', 'totalAnnualConsumption', 'year'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    water_sources: valueSchema,
  },
}
